import React from "react";

import { Icon } from "aible";
import Select from "react-select";

import { LineInput } from "components/Inputs/LineInput";

import DatasetTile from "components/Tiles/DatasetTile";

import styles from "./style.module.css";

export default class BusinessChooseSuccess extends React.PureComponent {
  render() {
    const {
      blueprintId,
      id,
      isShow,
      options,

      step,
      index,

      datasetView,
      selectedDataset,
      outcomeType,
      updateSelection,
      selectedSuccess,
      successOptions,
      updateSuccess,
      correlations,
      ignored,
      updateIgnored,

      subgroups,
      subgroupOptions,
      updateBusinessSubgroupLabel,
      updateBusinessSubgroupValue
    } = this.props;

    if (!selectedDataset) {
      return (
        <div className={styles.outcomeOptions} style={{ width: "100%", opacity: isShow === true ? 1 : 0 }}>
          <div id="businessChooseSuccess" style={{ width: "100%" }}>
            <div style={{ padding: "20px", minHeight: "300px" }}>{"No Dataset Selected"}</div>
          </div>
        </div>
      );
    }

    const isRegressionDataset = outcomeType === "number";
    const isSuccessSelected = selectedDataset && (selectedSuccess || isRegressionDataset);
    const hasProblematicPredictors = correlations && correlations.length > 0;

    return (
      <div className={styles.outcomeOptions} style={{ width: "100%", opacity: isShow === true ? 1 : 0 }}>
        <div className={styles.noStepWrapper} id="businessChooseSuccess" style={{ width: "100%" }}>
          <div className={styles.businessChooseWrapper}>
            <div className={styles.businessChooseCol}>
              <div className={styles.businessChooseItem}>
                <div className={styles.businessSelectedItem}>
                  <div className={styles.selectHeader} style={{ marginLeft: "10px" }}>
                    <Icon type={"dataset"} />
                    <div className={styles.selectHeaderText}>{"Selected Dataset"}</div>
                  </div>
                  <DatasetTile dataset={selectedDataset} />
                </div>
              </div>
            </div>

            {!isRegressionDataset ? (
              <div className={styles.businessChooseCol + " " + styles.businessPredictWrapper}>
                <div className={styles.businessPredict}>
                  <div className={styles.selectHeader} style={{ marginLeft: "10px", padding: "0px" }}>
                    <Icon type={"target"} />
                    <div className={styles.selectHeaderText}>{"Predict"}</div>
                  </div>
                  <div className={styles.selectSubHeader}>
                    {"Now that you have selected a dataset choose the outcome of " +
                      selectedDataset.outcome +
                      " that you would like to predict."}
                  </div>

                  <div className={styles.chooseSuccess}>
                    <div className={styles.selectLabel}>{selectedDataset.outcome + " is:"}</div>
                    <Select
                      key={selectedSuccess ? "success" : "undefined"}
                      value={selectedSuccess}
                      onChange={(value) => updateSuccess(value)}
                      options={successOptions}
                      className={styles.outcomePicker}
                      placeholder="Select Value"
                      menuPlacement="top"
                      isMulti={successOptions && successOptions.length > 2}
                    />
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            <div className={styles.businessChooseCol + " " + styles.businessSubGroupsWrapper}>
              <div className={styles.businessSubgroups}>
                <div className={styles.selectHeader} style={{ marginLeft: "10px", padding: "0px" }}>
                  <Icon type={"balance"} />
                  <div className={styles.selectHeaderText}>{"Variable(s) to dynamically balance"}</div>
                </div>
                <div className={styles.selectSubHeader}>
                  {"Aible can help allocate resources across different subgroups like departments and regions"}
                </div>
                <div className={styles.chooseSubgroups}>
                  <div className={styles.selectLabel}>{"Subgroups to investigate:"}</div>
                  <div className={styles.subgroupSelectorWrapper}>
                    {(subgroups || [{}, {}]).map((elem, i, subgroups) => (
                      <SubgroupSelector
                        key={i}
                        subgroup={elem}
                        subgroupOptions={subgroupOptions}
                        updateBusinessSubgroupValue={(v) => updateBusinessSubgroupValue(i, v)}
                        updateBusinessSubgroupLabel={(v) => updateBusinessSubgroupLabel(i, v)}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {isSuccessSelected ? (
            <div className={styles.correlationWrapper}>
              <div className={styles.problematicPredictors}>
                <div className={styles.selectHeader} style={{ marginLeft: "10px", padding: "0px" }}>
                  <Icon type={"warning"} />
                  <div className={styles.selectHeaderText}>{"Problematic Predictors Detected"}</div>
                </div>
                <div className={styles.selectSubHeader}>
                  {"The following columns are very good predictors of " +
                    selectedDataset.outcome +
                    ". (Maybe a little too good...) Would your AI have access to this information at the time of making a prediction? " +
                    "If not, you should remove it because otherwise you are expecting your AI to time-travel. " +
                    "If they are mathematically related (such as calculated fields), you should also remove them."}
                </div>
                <div className={styles.predictorsList}>
                  {hasProblematicPredictors ? (
                    correlations.map((field) => (
                      <ProblematicPredictor
                        key={field.label}
                        predictor={field}
                        updateIgnored={updateIgnored}
                        isIgnored={ignored && ignored[field.label]}
                        isLocked={options && options["lock"]}
                      />
                    ))
                  ) : (
                    <div className={styles.problematicPredictorLabel} style={{ marginLeft: "0px" }}>
                      {"No problematic predictors found."}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

class ProblematicPredictor extends React.PureComponent {
  render() {
    const { predictor, updateIgnored, isIgnored, isLocked } = this.props;
    return (
      <div className={styles.problematicPredictorWrapper} title={predictor.label}>
        <div className={styles.checkbox}>
          <input
            type="checkbox"
            checked={isIgnored}
            onChange={isLocked ? () => {} : () => updateIgnored(predictor.label, !isIgnored)}
          />
        </div>
        <div
          className={styles.problematicPredictorLabel}
          style={{ opacity: isIgnored ? 0.3 : 1 }}
          onClick={() => updateIgnored(predictor.label, !isIgnored)}
        >
          {"Remove"}
          <span>{predictor.label}</span>
        </div>
        <div className={styles.problematicPredictorBar} style={{ opacity: isIgnored ? 0.3 : 1 }}>
          <div className={styles.problematicPredictorBarFill} style={{ width: predictor.correlation * 100 + "%" }}>
            <span className={styles.problematicPredictorBarLabel}>
              {(predictor.correlation * 100).toFixed(2) + "%"}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

class SubgroupSelector extends React.PureComponent {
  render() {
    const { subgroup, subgroupOptions, updateBusinessSubgroupLabel, updateBusinessSubgroupValue } = this.props;

    const currValue = {
      value: subgroup.value,
      label: subgroup.value
    };
    const currLabel = subgroup.label;
    return (
      <div className={styles.subgroupSelector}>
        <div className={styles.chooseSubgroup}>
          <div className={styles.subgroupLabel}>{"Variable:"}</div>
          <Select
            value={currValue}
            onChange={(s) => {
              updateBusinessSubgroupLabel(s.value);
              return updateBusinessSubgroupValue(s.value);
            }}
            options={subgroupOptions}
            className={styles.subgroupPicker}
            maxMenuHeight={200}
            placeholder="Select"
            menuPlacement="top"
          />
        </div>
        <div className={styles.chooseSubgroup}>
          <div className={styles.subgroupLabel}>{"Subgroup Name:"}</div>
          <LineInput
            className={styles.subgroupInput}
            value={currLabel}
            onChange={(v) => updateBusinessSubgroupLabel(v)}
            isMediumBox
          />
        </div>
      </div>
    );
  }
}
